import { render, staticRenderFns } from "./LicitacaoFornecedorTermos.vue?vue&type=template&id=bcf85b02"
import script from "./LicitacaoFornecedorTermos.vue?vue&type=script&lang=js"
export * from "./LicitacaoFornecedorTermos.vue?vue&type=script&lang=js"
import style0 from "./LicitacaoFornecedorTermos.vue?vue&type=style&index=0&id=bcf85b02&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports